module.exports = __webpack_public_path__ + "4343c9c1a25d153bb65002d22c18f499.png";